import DashboardPage from './DashboardPage';
import './dashboard.scss'

export default DashboardPage;